import { Activity, Message } from 'botframework-directlinejs';
import { getCurrentFeedback } from './get-current-feedback';

export const getActivitiesWithFeedback = (activity: any, currentActivities: Activity[]): Activity[] => {
  if ((activity.type as any) === 'messageReaction') {
    const { replyToId } = activity as any;
    const targetActivity = currentActivities.find(act => act.id === replyToId) as Message;
    if (targetActivity) {
      const currentFeedback = getCurrentFeedback(activity);
      const newActivity = {
        ...targetActivity,
        value: {
          ...(targetActivity.value ? targetActivity.value : {}),
          currentFeedback,
        } as any,
      };

      return currentActivities.map(act => (act.id === replyToId ? newActivity : act));
    }
  }

  return currentActivities;
};
